function FileNameFilter() {
  'ngInject';
  return function (input) {
    let fileName = input.split('/');
    return fileName[fileName.length - 1];
  };
}
export default {
  name: 'FileNameFilter',
  fn: FileNameFilter
};